import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className='bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 py-4 shadow-md fixed top-0 left-0 right-0 z-50'>
      <div className='container'>
        <div className='flex justify-between items-center'>
          <Link
            to='/'
            className='text-2xl md:text-xl font-bold text-teal-500 hover:text-teal-400 transition-colors duration-300 cursor-pointer'
          >
            Nethra App
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
